<template lang="pug">
v-hover(v-slot="{ hover }", :open-delay="200", :close-delay="200", disabled)
  v-expansion-panels(hover, dense, :value="hover ? 0 : undefined")
    v-expansion-panel
      v-card
        v-expansion-panel-header
          v-card-title {{$t(`pd.${mainset_id}.name`)}}
        v-expansion-panel-content
          v-card-subtitle ({{$t(`pd.${mainset_id}.period`)}})
          v-card-text {{$t(`pd.${mainset_id}.desc`)}}
</template>
<script>
export default {
  name: "CollectionInfo",
  props: {
    pd: {},
  },
  setup(props) {
    return {
    }
  }
}
</script>
